import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Succès — cercle + check duotone */
export const SuccessIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path d="M8 12l3 3 5-6" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);
SuccessIcon.displayName = "SuccessIcon";
